function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { FormHelperText } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import _merge from 'lodash/merge';
import { Typography } from "../Typography/index.js";
import { Box } from "../Box/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { CONSTANTS } from "../../theme/constants/index.js";
import { color } from "../../utils/index.js";
export var SIZES = {
  SMALL: 'small',
  DEFAULT: 'default'
};
export var VARIANTS = {
  DESKTOP: 'desktop',
  PWA: 'pwa'
};
export var InputField = function InputField(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? VARIANTS.PWA : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZES.DEFAULT : _ref$size,
    type = _ref.type,
    autoComplete = _ref.autoComplete,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    isFocused = _ref.isFocused,
    isSearchField = _ref.isSearchField,
    isTextArea = _ref.isTextArea,
    helperText = _ref.helperText,
    label = _ref.label,
    error = _ref.error,
    name = _ref.name,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    maxRows = _ref.maxRows,
    minRows = _ref.minRows,
    placeholder = _ref.placeholder,
    id = _ref.id,
    testId = _ref.testId,
    helperTextTestId = _ref.helperTextTestId,
    inputProps = _ref.inputProps,
    InputProps = _ref.InputProps,
    className = _ref.className,
    _onClick = _ref.onClick,
    _onChange = _ref.onChange,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    handleIconClick = _ref.handleIconClick,
    leadingTag = _ref.leadingTag,
    sx = _ref.sx,
    disableLeftBorderRadius = _ref.disableLeftBorderRadius,
    disableRightBorderRadius = _ref.disableRightBorderRadius,
    inputRef = _ref.inputRef,
    _onKeyUp = _ref.onKeyUp,
    _onKeyDown = _ref.onKeyDown,
    shrink = _ref.shrink;
  var theme = useTheme();
  var _useState = useState(!!value || !!defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    isDirty = _useState2[0],
    setIsDirty = _useState2[1];
  var _useState3 = useState(value),
    _useState4 = _slicedToArray(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var tagMargin = function tagMargin() {
    if (theme.direction === CONSTANTS.LTR) {
      return {
        marginRight: '4px'
      };
    }
    return {
      marginLeft: '4px'
    };
  };
  var getInputHeight = function getInputHeight() {
    if (variant === VARIANTS.DESKTOP) {
      if (size === SIZES.SMALL) {
        return leadingTag || leadingIcon ? '10px 12px 10px 0' : '10px 12px';
      }
      if (size === SIZES.DEFAULT) {
        return leadingTag || leadingIcon ? '14px 12px 14px 0' : '14px 12px';
      }
    }
    if (variant === VARIANTS.PWA && size === SIZES.DEFAULT) {
      return leadingTag || leadingIcon ? '16.5px 16px 16.5px 0px ' : '16.5px 16px';
    }
    return leadingTag || leadingIcon ? '16.5px 16px 16.5px 0px ' : '16.5px 16px';
  };
  var helpterTextMargin = function helpterTextMargin() {
    if (variant === VARIANTS.DESKTOP) {
      if (size === SIZES.SMALL) {
        return '0px';
      }
      if (size === SIZES.DEFAULT) {
        return '12px';
      }
    }
    return '16px';
  };
  useEffect(function () {
    setInputValue(value);
    if (value && value.length > 0 || defaultValue && defaultValue.length > 0) {
      setIsDirty(true);
    } else {
      setIsDirty(false);
    }
  }, [value, defaultValue]);
  var inputCss = {
    '&.disableLeftBorderRadius': {
      '& .MuiOutlinedInput-root': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        marginLeft: '-1px',
        '&.Mui-focused': {
          zIndex: 2
        }
      }
    },
    '&.disableRightBorderRadius': {
      '& .MuiOutlinedInput-root': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        '&.Mui-focused': {
          zIndex: 2
        }
      }
    },
    '& .MuiOutlinedInput-root': {
      background: isSearchField ? '' : color(COLOR_VARIANTS.WHITE)
    }
  };
  var customInput = {
    '&.MuiTextField-root': {
      width: '100%',
      background: isSearchField ? color(COLOR_VARIANTS.ALICE) : '',
      overflow: isSearchField ? 'hidden' : '',
      borderRadius: isSearchField ? '12px' : ''
    },
    '& .root': {
      background: isSearchField ? color(COLOR_VARIANTS.ALICE) : 'auto'
    },
    '&.custom-textarea': {
      '& .MuiOutlinedInput-root': {
        padding: 0,
        '& .MuiOutlinedInput-input': {
          padding: '16.5px 14px'
        },
        '& .MuiIconButton-root': {
          marginRight: 0
        }
      }
    },
    '&.custom-search': {
      '& .MuiOutlinedInput-root': {
        padding: '0 16px',
        '& .MuiOutlinedInput-input': {
          padding: '8.5px 0',
          '&:placeholder': {
            color: error ? color(COLOR_VARIANTS.CRIMSON100) : color(COLOR_VARIANTS.GREYCHATEAU)
          }
        }
      }
    },
    '& .MuiInputLabel-outlined': {
      color: color(COLOR_VARIANTS.GREYCHATEAU),
      fontSize: variant === VARIANTS.DESKTOP ? 14 : 16,
      top: variant === VARIANTS.DESKTOP ? '-2px' : '',
      background: isSearchField ? color(COLOR_VARIANTS.ALICE) : '',
      '&.MuiInputLabel-shrink': {
        top: variant === VARIANTS.DESKTOP ? '2px' : ''
      }
    },
    '& .MuiInputBase-input': {
      color: color(COLOR_VARIANTS.MINESHAFT),
      background: isSearchField ? color(COLOR_VARIANTS.ALICE) : '',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      // padding: variant === VARIANTS.DESKTOP ? '0 12px' : '0 16px',
      padding: getInputHeight(),
      // height: variant === VARIANTS.DESKTOP ? 48 : 56,
      fontSize: variant === VARIANTS.DESKTOP ? 14 : 16,
      '&:placeholder': {
        color: error ? color(COLOR_VARIANTS.CRIMSON100) : color(COLOR_VARIANTS.GREYCHATEAU),
        opacity: 1
      }
    },
    '& > .Mui-focused': {
      color: color(COLOR_VARIANTS.MINESHAFT)
    },
    '& label.Mui-focused': {
      color: color(COLOR_VARIANTS.AQUA100)
    },
    '& .Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: isSearchField ? 'none !important' : "1px solid ".concat(color(COLOR_VARIANTS.AQUA100), "!important")
      }
    },
    '& > .Mui-disabled': {
      color: color(COLOR_VARIANTS.MINESHAFT)
    },
    '& label.Mui-disabled': {
      color: color(COLOR_VARIANTS.GREYCHATEAU)
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: isSearchField ? 'none !important' : "1px solid ".concat(color(COLOR_VARIANTS.GAINSBORO)),
      '&:hover': {
        border: 'none !important'
      }
    },
    '& .MuiOutlinedInput-root': {
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: color(COLOR_VARIANTS.GAINSBORO)
        }
      }
    },
    '& .Mui-disabled': {
      // background: color(COLOR_VARIANTS.ALICE),

      color: color(COLOR_VARIANTS.GREYCHATEAU),
      textFillColor: color(COLOR_VARIANTS.GREYCHATEAU),
      '& > .MuiIconButton-root > svg, & .MuiInputAdornment-root > svg ': {
        color: color(COLOR_VARIANTS.GREYCHATEAU)
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: isSearchField ? 'none !important' : "1px solid ".concat(color(COLOR_VARIANTS.ALICE), " !important"),
        color: "".concat(color(COLOR_VARIANTS.CRIMSON100), " !important")
      }
    }
  };
  var leadingIconStyle = {
    '& .MuiInputLabel-outlined': {
      textIndent: 32
    },
    '& .MuiInputLabel-shrink': {
      textIndent: 0
    }
  };
  var errorInput = {
    '& .MuiInputLabel-root': {
      color: "".concat(color(COLOR_VARIANTS.CRIMSON100), " !important")
    },
    '& .Mui-error, .Mui-error.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: "1px solid ".concat(color(COLOR_VARIANTS.CRIMSON100), " !important"),
        color: "".concat(color(COLOR_VARIANTS.CRIMSON100), " !important"),
        borderRadius: isSearchField ? '12px' : ''
      }
    },
    '& .MuiFormHelperText-root': {
      color: "".concat(color(COLOR_VARIANTS.CRIMSON100), " !important")
    }
  };
  var iconButtonStyles = {
    background: 'none !important'
  };
  var errorInputLabel = {
    color: "".concat(color(COLOR_VARIANTS.CRIMSON100), " !important")
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, variant === VARIANTS.DESKTOP && size === SIZES.SMALL && label && /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.CAPTIONSEMBLD,
    color: COLOR_VARIANTS.MINESHAFT,
    component: "h4",
    sx: _merge({
      marginBottom: '8px',
      color: isDisabled ? "".concat(color(COLOR_VARIANTS.GREYCHATEAU), " ") : ''
    }, error ? errorInputLabel : '')
  }, label, isRequired && /*#__PURE__*/React.createElement(Box, {
    sx: _merge({
      color: isDisabled ? "".concat(color(COLOR_VARIANTS.GREYCHATEAU), " ") : color(COLOR_VARIANTS.AQUA100),
      display: 'inline-flex',
      margin: '0 5px'
    }, error ? errorInputLabel : '')
  }, "*")), /*#__PURE__*/React.createElement(TextField, {
    label: size !== SIZES.SMALL ? label : '',
    name: name,
    variant: "outlined",
    type: type,
    placeholder: placeholder,
    autoComplete: autoComplete,
    id: id || testId,
    className: "__ds__comp ".concat(isTextArea ? 'custom-textarea' : '').concat(isSearchField ? 'custom-search' : '', " ").concat(disableLeftBorderRadius ? 'disableLeftBorderRadius' : '', " ").concat(disableRightBorderRadius ? 'disableRightBorderRadius' : '', " ").concat(className || ''),
    value: inputValue,
    onClick: function onClick(e) {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
    },
    defaultValue: defaultValue,
    disabled: isDisabled,
    required: isRequired,
    multiline: isTextArea,
    minRows: minRows || 8,
    maxRows: maxRows || 8,
    error: error,
    focused: isFocused,
    "data-testid": testId,
    onBlur: function onBlur(e) {
      if (e.target && e.target.value.length > 0) setIsDirty(true);else setIsDirty(false);
      _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
    },
    sx: _merge(inputCss, error ? errorInput : '', customInput, leadingIcon ? leadingIconStyle : inputCss, sx),
    onFocus: function onFocus(e) {
      setIsDirty(true);
      _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(e);
    },
    onChange: function onChange(e) {
      // @ts-ignore
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
      setInputValue(e.target.value);
    },
    onKeyUp: function onKeyUp(e) {
      // @ts-ignore
      _onKeyUp === null || _onKeyUp === void 0 ? void 0 : _onKeyUp(e);
    },
    onKeyDown: function onKeyDown(e) {
      // @ts-ignore
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e);
    },
    InputLabelProps: {
      shrink: shrink || isDirty
    },
    inputRef: inputRef,
    inputProps: inputProps,
    InputProps: InputProps || {
      startAdornment: leadingIcon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, leadingIcon), leadingTag && /*#__PURE__*/React.createElement("div", {
        style: tagMargin()
      }, leadingTag)),
      endAdornment: trailingIcon && /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return handleIconClick === null || handleIconClick === void 0 ? void 0 : handleIconClick();
        },
        edge: "end",
        sx: iconButtonStyles
      }, trailingIcon)
    }
  }), helperText && /*#__PURE__*/React.createElement(FormHelperText, {
    "data-testid": helperTextTestId,
    sx: {
      display: 'block',
      color: error ? color(COLOR_VARIANTS.CRIMSON100) : color(COLOR_VARIANTS.GREYCHATEAU),
      fontSize: '12px',
      mt: size === SIZES.SMALL ? '4px !important' : '8px !important',
      ml: helpterTextMargin()
    }
  }, helperText));
};